<template lang="pug">
  v-dialog(v-model="show" persistent max-width="500")
    v-card
      v-card-title(class="headline") Задача
        v-spacer
        v-btn(icon, @click="$emit('close-issue-item')").ma-0
          v-icon close
      v-card-text
        v-form(ref="form")
          v-layout(justify-center)
            v-flex(xs12)
              span.upperLine Назначил
              v-text-field(solo flat v-model="issueItem.creator" disabled)
              span.upperLine Исполнитель
              v-text-field(solo flat v-model="issueItem.implementer" disabled)
              span.upperLine Дата назначения
              v-text-field(solo flat v-model="issueItem.appointmentDate" disabled)
              span.upperLine Исполнить до
              v-text-field(solo flat v-model="issueItem.dueDate" disabled)
              span.upperLine Фио ребенка
              v-text-field(solo flat v-model="issueItem.childFio" disabled)
              span.upperLine Потребности ребенка, выявленые при проведении всесторонней оценки
              v-textarea(solo flat v-model="issueItem.requirenment" disabled)
              span.upperLine Мероприятия по предоставлению ребенку находящемуся в ТСЖ соответствующей помощи и услуг
              v-textarea(solo flat v-model="issueItem.event" disabled)
              span.upperLine Ожидаемый результат
              v-text-field(solo flat v-model="issueItem.expectedResult" disabled)
              span.upperLine Отметка об исполнении/неисполнении (причина)
              v-textarea(solo flat v-model="comment")
          v-layout(justify-center)
            v-btn(large, outline, color="primary", @click="$emit('close-issue-item')") Закрыть
            v-btn(large, color="primary", :disabled="disabled" @click.prevent="onSubmit") Выполено
</template>

<script>
import axios from 'axios'
export default {
  name: 'IssueItem',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data: () => ({
    issueItem: {
      creator: '',
      implementer: '',
      appointmentDate: '',
      dueDate: '',
      childFio: '',
      requirenment: '',
      event: '',
      expectedResult: '',
      error: ''
    },
    comment: '',
    disabled: true
  }),
  watch: {
    item({
      creator,
      implementer,
      appointmentDate,
      dueDate,
      childFio,
      requirenment,
      event,
      expectedResult
    }) {
      const item = this.issueItem
      item.creator = creator
      item.implementer = implementer
      item.appointmentDate = appointmentDate
      item.dueDate = dueDate
      item.childFio = childFio
      item.requirenment = requirenment
      item.event = event
      item.expectedResult = expectedResult
    },
    comment(val) {
      this.disabled = !val
    }
  },
  methods: {
    async onSubmit() {
      try {
        await axios({
          method: 'PUT',
          url: `/api/issue/edit/${this.item.id}`,
          data: { comment: this.comment }
        })
        this.$emit('close-issue-item')
        this.$emit('get-issue-list')
      } catch (e) {
        this.error = e
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/IssueStructure/IssueItem/IssueItem.vue